import React, { useCallback, useEffect } from "react";
import TableContainer from "../../../ui/TableContainer";
import { useUserAccounts } from "../provider";
import { Pagination } from "../../../ui";
import { useUtils } from "../../../services/utilsProvider";
import { useNavigate } from "react-router-dom";

const ListTimerKeeper = ({ company }) => {
  const { alertUser, notify } = useUtils();
  const navigate = useNavigate();

  const cols = [
    { name: "displayName", label: "Display Name" },
    { name: "username", label: "Username" },
  ];

  const {
    state: {
      timerKeeperList,
      tkStatus,
      tkCount,
      tkPerPage,
      tkpage,
      pochangeStatus,
    },
    fetchTimerKeeperList,
    setTimerKeeper,
    dispatch,
  } = useUserAccounts();

  useEffect(() => {
    if (company.id) fetchTimerKeeperList(company.id, tkpage + 1, 10);
  }, [company.id, tkpage, pochangeStatus]);

  const handleChangePage = useCallback(
    (event, newPage) =>
      newPage && dispatch({ type: "set_tkPage", payload: newPage }),
    [dispatch]
  );

  const handleRevokeTK = useCallback(
    async (id) => {
      try {
        await setTimerKeeper(id, { grant: false });
        dispatch({ type: "pochangeStatus", payload: `changed` });
        dispatch({ type: "pochangeStatus", payload: `idle` });
        dispatch({ type: "tkStatus", payload: `changed` });
        dispatch({ type: "tkStatus", payload: `idle` });
        notify("a Timer Keeper Role has been revoked successfully.");
      } catch (e) {
        alertUser("not a timer keeper");
      }
    },
    [navigate]
  );

  return (
    <div>
      <TableContainer
        empty={timerKeeperList?.length === 0}
        status={tkStatus}
        aria-label="Holidays table"
        cols={cols}
        moreOptions={{
          setAsTimerKeeper: {
            label: "ٌRevoke Timer Keeper Role",
            icon: "",
            fn: handleRevokeTK,
          },
        }}
        data={timerKeeperList}
      />
      <Pagination
        data-testid="pagination"
        count={tkCount}
        page={tkpage}
        rowsPerPage={tkPerPage}
        onPageChange={handleChangePage}
      />
    </div>
  );
};

export default ListTimerKeeper;
